import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_ERROR = 'SUBSCRIBE_ERROR';

export const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_ERROR = 'UNSUBSCRIBE_ERROR';

export function subscribe(orderId) {
	return dispatch => {
		dispatch(requestSubscribe());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/self-serve/subscribe?orderId=${orderId}`
			})
		).then(
			json => dispatch(receiveSubscribeSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveSubscribeError(err));
				return Promise.reject(err['RESPONSE'] || err);
			}
		);
	};
}

const requestSubscribe = () => {
	return {
		type: SUBSCRIBE_REQUEST
	};
};

const receiveSubscribeSuccess = response => {
	return {
		type: SUBSCRIBE_SUCCESS,
		data: response
	};
};

const receiveSubscribeError = errorParam => {
	return {
		type: SUBSCRIBE_ERROR,
		error: errorParam
	};
};

export function unsubscribe(orderId) {
	return dispatch => {
		dispatch(requestUnsubscribe());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/self-serve/unsubscribe?orderId=${orderId}`
			})
		).then(
			json => dispatch(receiveUnsubscribeSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveUnsubscribeError(err));
				return Promise.reject(err['RESPONSE'] || err);
			}
		);
	};
}

const requestUnsubscribe = () => {
	return {
		type: UNSUBSCRIBE_REQUEST
	};
};

const receiveUnsubscribeSuccess = response => {
	return {
		type: UNSUBSCRIBE_SUCCESS,
		data: response
	};
};

const receiveUnsubscribeError = errorParam => {
	return {
		type: UNSUBSCRIBE_ERROR,
		error: errorParam
	};
};
